import { enableProdMode, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { MncNotificationModule as MncNotificationModule } from '@app/mnc-notification.module';
import { environment } from '@env/environment';

if (environment.production) {
  enableProdMode();
}

const { buildNumber, commit } = environment.version;

console.log('Notification.MFE UI Version:', {
  buildNumber,
  commit,
})

platformBrowserDynamic()
  .bootstrapModule(MncNotificationModule, {
    applicationProviders: [provideZoneChangeDetection()],
    providers: [{ provide: LOCALE_ID, useValue: 'en-US' }]
  })
  .catch((err) => console.error(err));
